import React, { useContext } from "react";
import { Filter } from "../../models/Filter";
import { ContextToggle } from "./ContextToggle";
import { Lookup } from "../../models/Lookup";
import { MultiSelectOption } from "../../models/MultiSelectOption";

export interface FilterContextValueType extends ContextToggle {
    filters: Filter[];
    updateFilters: (columnId: string, itemId: any, itemValue: string, columnKey?: string, elementSysname?: string) => void;
    updateNonColumnFilter: (newSelectedOption: MultiSelectOption, filterKey: string, filterLabel: string, isSingleSelect: boolean, options?: MultiSelectOption[]) => Promise<void>;
    closeFilter: (accessor: string) => Promise<void>;
    lookup?: Lookup[];
}

export const emptyFilterContextValue: FilterContextValueType = {
    isInUse: false,
    filters: new Array(0),
    updateFilters: (columnId, itemId, itemValue, columnKey, elementSysname) => { },
    closeFilter: (accessor) => Promise.resolve(),
    updateNonColumnFilter: (newSelectedOption, filterKey, filterLabel, isSingleSelect, options) => Promise.resolve(),
    lookup: []
}

export const useFilter = () => {
    return useContext(FilterContext)
}

export const FilterContext = React.createContext<FilterContextValueType>(emptyFilterContextValue);

